import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmDialogService } from 'src/app/adminUsers/confirm-dialog/confirm-dialog.service';
import { DataService } from 'src/app/Service/data.service';
import { MainService } from 'src/app/Service/main.service';

@Component({
  selector: 'app-tanet-feedback',
  templateUrl: './tanet-feedback.component.html',
  styleUrls: ['./tanet-feedback.component.scss']
})
export class TanetFeedbackComponent implements OnInit {
  constructor(private DataServiceObj: DataService,
              private fb: FormBuilder, private route: Router,
              private router: ActivatedRoute,
              private confirmDialogService: ConfirmDialogService,
              private Mainservice: MainService, private activatedRoute: ActivatedRoute) { }
  @ViewChild('pricingCloneModal') private pricingCloneModal: ElementRef;
  term: string;
  p = 1;
  total: any = 0;
  response;
  reportsData = [];
  selected = [];
  walletChecked = false;
  billingAddressFlag = false;

  SubscriberPaymentForm = this.fb.group({
    id: ['', [ ]]
  });

  tenantForm = this.fb.group({
    id: new FormControl('', [  removeSpaces]),

    tenantFeedbackSettingId: new FormControl('', [  removeSpaces]),
    tenantManagementId: new FormControl(''),
    isPaymentOnTime: new FormControl('', [  removeSpaces]),
    applicantVioletedIn3Months: new FormControl('', [  removeSpaces]),
    isRentNonPaymentAmount: new FormControl('', [  removeSpaces]),
    rentDelayedByDays: new FormControl('', [  removeSpaces]),

    rentNonPaymentAmount: new FormControl('', [  removeSpaces]),
    isNSFCheckCount: new FormControl('', [  removeSpaces]),
    NSFCheckCount: new FormControl('', [  removeSpaces]),
    isEvictionUDFilled: new FormControl('', [  removeSpaces]),
    judgmentAmount: new FormControl('', [  removeSpaces]),
    isAuthorizedOccupants: new FormControl('', [  removeSpaces]),
    isLatePayments: new FormControl('', [  removeSpaces]),
    noOfLatePayments: new FormControl('', [  removeSpaces]),
    isOtherLeaseViolations: new FormControl('', [  removeSpaces]),
    isSection8Fraud: new FormControl('', [  removeSpaces]),
    isTurnOverToCollections: new FormControl('', [  removeSpaces]),
    turnOverCollectionsAmount: new FormControl('', [  removeSpaces]),
    isSection8Violations: new FormControl('', [  removeSpaces]),
    isUtilitiesNonPayment: new FormControl('', [  removeSpaces]),
    utilitiesNonPaymentAmount: new FormControl('', [  removeSpaces]),
    isSkipWithoutNotice: new FormControl('', [  removeSpaces]),
    isUnauthorizedPets: new FormControl('', [  removeSpaces]),
    isKeysNotReturned: new FormControl('', [  removeSpaces]),
    isNoticeToVacate: new FormControl('', [  removeSpaces]),
    isTryingToLocate: new FormControl('', [  removeSpaces]),
    isDamages: new FormControl('', [  removeSpaces]),
    damageAmount: new FormControl('', [  removeSpaces]),
    isPaidInFull: new FormControl('', [  removeSpaces]),
    paidDate: new FormControl('', [  removeSpaces]),
    isGoodResidentNoVoilation: new FormControl('', [  removeSpaces])

  });

  add_offer = false;
  flag_add_status = true;
  flag_table = true;
  flag_form = false;
  showData: boolean;
  btn_name = 'Add';
  page_title = 'Add Details';
  page_name = 'Tenant Feedback';
  tenantDetails: any[];
  tenantDetailObj: any;
  token: string;

  subscriberId: any;

  ngOnInit(): void {
    this.router.params.subscribe(params => {
      params.Token != undefined ? this.subscriberId = params.Token : null;
      console.log('token****', this.subscriberId);
    });
    this.gettenantDetails(this.token);
  }
  // ngOnInit(): void {
  //   console.log('came')
  //   const userToken = this.DataServiceObj.getUserToken();
  //   // if (!userToken) {
  //   //   this.route.navigate(['/login']);
  //   // } else {
  //     this.route.navigate(['/tenant-feedback-data']);
  //     var clicks = JSON.parse(sessionStorage.getItem('subscriberLogin'));
  //     if (clicks.token) {
  //       this.subscriberId = clicks.Data.subscriberId;
  //     } else {
  //       this.subscriberId = clicks.Data.id;
  //     }
  //     this.gettenantDetails(userToken);
  //   // }

  // }

  back() {
    this.flag_form = false;
    this.flag_table = true;
  }

  gettenantDetails(uy) {
    console.log('came', this.subscriberId);
    const userToken = this.DataServiceObj.getUserToken();
      // this.DataServiceObj.tenantSales('admin/tenantManagement/getAllTenantManagement', { subscriberId: this.subscriberId }).subscribe(res => {

    this.DataServiceObj.tenantSales('admin/tenantFeedbackSetting/getAllTenantFeedbackSetting', { subscriberId: this.subscriberId }).subscribe(res => {
      this.response = res;
      this.reportsData = this.response.Data;
      console.log(res);

      // this.reportsData=this.response.Data.filter(v=>v.subscriberId==this.subscriberId)
    },
      err => {
        console.log(err);
       });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  add() {
    this.btn_name = 'Add';
    this.add_offer = false;
    this.flag_table = false;
    this.flag_form = true;
    this.flag_add_status = true;
    this.page_name = 'Tenant Edit';
    this.tenantForm = this.fb.group({
      id: new FormControl('', [  removeSpaces]),
      tenantFeedbackSettingId: new FormControl('', [  removeSpaces]),
      tenantManagementId: new FormControl(''),

      isPaymentOnTime: new FormControl('', [  removeSpaces]),
      applicantVioletedIn3Months: new FormControl('', [  removeSpaces]),
      isRentNonPaymentAmount: new FormControl('', [  removeSpaces]),
      rentDelayedByDays: new FormControl('', [  removeSpaces]),

      rentNonPaymentAmount: new FormControl('', [  removeSpaces]),
      isNSFCheckCount: new FormControl('', [  removeSpaces]),
      NSFCheckCount: new FormControl('', [  removeSpaces]),
      isEvictionUDFilled: new FormControl('', [  removeSpaces]),
      judgmentAmount: new FormControl('', [  removeSpaces]),
      isAuthorizedOccupants: new FormControl('', [  removeSpaces]),
      isLatePayments: new FormControl('', [  removeSpaces]),
      noOfLatePayments: new FormControl('', [  removeSpaces]),
      isOtherLeaseViolations: new FormControl('', [  removeSpaces]),
      isSection8Fraud: new FormControl('', [  removeSpaces]),
      isTurnOverToCollections: new FormControl('', [  removeSpaces]),
      turnOverCollectionsAmount: new FormControl('', [  removeSpaces]),
      isSection8Violations: new FormControl('', [  removeSpaces]),
      isUtilitiesNonPayment: new FormControl('', [  removeSpaces]),
      utilitiesNonPaymentAmount: new FormControl('', [  removeSpaces]),
      isSkipWithoutNotice: new FormControl('', [  removeSpaces]),
      isUnauthorizedPets: new FormControl('', [  removeSpaces]),
      isKeysNotReturned: new FormControl('', [  removeSpaces]),
      isNoticeToVacate: new FormControl('', [  removeSpaces]),
      isTryingToLocate: new FormControl('', [  removeSpaces]),
      isDamages: new FormControl('', [  removeSpaces]),
      damageAmount: new FormControl('', [  removeSpaces]),
      isPaidInFull: new FormControl('', [  removeSpaces]),
      paidDate: new FormControl('', [  removeSpaces]),
      isGoodResidentNoVoilation: new FormControl('', [  removeSpaces])

    });

  }

  save() {
    const obj = this;
    if (obj.tenantForm.value.id == null || obj.tenantForm.value.id == '' || obj.tenantForm.value.id == undefined)
{
obj.tenantForm.patchValue({tenantManagementId: obj.tenantDetailObj.tenantManageId});
}
    obj.tenantForm.value.userId = obj.tenantForm.value.id;

    const data = obj.tenantForm.value;
    obj.flag_table = true;
    obj.flag_form = false;

    // console.log(obj.tenantForm.value)
    // obj.pricingCloneModal.nativeElement.click();

    obj.DataServiceObj.tenantSales('admin/tenantFeedbackSetting/updateTenantFeedbackSettingDetailsWithoutToken', data).subscribe((res: any) => {
        obj.response = res;

        if (obj.response.Status === 200) {

            obj.Mainservice.ShowAlert('Success', 'Tenant Updated Successfully');
            obj.pricingCloneModal.nativeElement.click();
            obj.gettenantDetails('err');

            // obj.getEditOrderDetails();
          } else {
          obj.pricingCloneModal.nativeElement.click();

          obj.Mainservice.ShowAlert('Error', 'Something went wrong. Please try after sometime');
          }

      });
    // }, function () {
    // })

  }
  openEdit() {
    this.flag_form = true;
    this.flag_table = false;
  }
  //   edit(obj){
  //     console.log(obj)
  //     this.tenantDetailObj=obj;
  //     this.flag_form=true;
  //     this.flag_table=false;
  //     console.log('ppp',obj.tenantFeedbackId)

  //     this.DataServiceObj.createUpdateSubscriber('admin/tenantFeedbackSetting/detailByIdTenantFeedbackSettingDetailsWithoutToken', { "id": obj.tenantFeedbackId }, this.token).subscribe(res => {
  //       console.log(1)
  //       console.log(res)
  //       this.response = res;

  //       if (this.response.Status == 200) {
  //         if (this.response.Data != null) {
  //           console.log(this.response.Data.recordset);
  // //            this.tenantForm.patchValue(this.response.Data.recordset[0]);
  // // {{this.tenantForm.value.isAuthorizedOccupants === 'true' ?this.tenantForm.patchValue({isAuthorizedOccupants:true}) :this.tenantForm.patchValue({isAuthorizedOccupants:false})}}
  // // {{this.tenantForm.value.isDamages === 'true' ?this.tenantForm.patchValue({isDamages:true}) :this.tenantForm.patchValue({isDamages:false})}}
  // // {{this.tenantForm.value.isEvictionUDFilled === 'true' ?this.tenantForm.patchValue({isEvictionUDFilled:true}) :this.tenantForm.patchValue({isEvictionUDFilled:false})}}
  // // {{this.tenantForm.value.isGoodResidentNoVoilation === 'true' ?this.tenantForm.patchValue({isGoodResidentNoVoilation:true}) :this.tenantForm.patchValue({isGoodResidentNoVoilation:false})}}
  // // {{this.tenantForm.value.isKeysNotReturned === 'true' ?this.tenantForm.patchValue({isKeysNotReturned:true}) :this.tenantForm.patchValue({isKeysNotReturned:false})}}
  // // {{this.tenantForm.value.isLatePayments === 'true' ?this.tenantForm.patchValue({isLatePayments:true}) :this.tenantForm.patchValue({isLatePayments:false})}}
  // // {{this.tenantForm.value.isNSFCheckCount === 'true' ?this.tenantForm.patchValue({isNSFCheckCount:true}) :this.tenantForm.patchValue({isNSFCheckCount:false})}}
  // // {{this.tenantForm.value.isNoticeToVacate === 'true' ?this.tenantForm.patchValue({isNoticeToVacate:true}) :this.tenantForm.patchValue({isNoticeToVacate:false})}}
  // // {{this.tenantForm.value.isOtherLeaseViolations === 'true' ?this.tenantForm.patchValue({isOtherLeaseViolations:true}) :this.tenantForm.patchValue({isOtherLeaseViolations:false})}}
  // // {{this.tenantForm.value.isPaidInFull === 'true' ?this.tenantForm.patchValue({isPaidInFull:true}) :this.tenantForm.patchValue({isPaidInFull:false})}}
  // // {{this.tenantForm.value.isRentNonPaymentAmount === 'true' ?this.tenantForm.patchValue({isRentNonPaymentAmount:true}) :this.tenantForm.patchValue({isRentNonPaymentAmount:false})}}
  // // {{this.tenantForm.value.isSection8Fraud === 'true' ?this.tenantForm.patchValue({isSection8Fraud:true}) :this.tenantForm.patchValue({isSection8Fraud:false})}}
  // // {{this.tenantForm.value.isSection8Violations === 'true' ?this.tenantForm.patchValue({isSection8Violations:true}) :this.tenantForm.patchValue({isSection8Violations:false})}}
  // // {{this.tenantForm.value.isSkipWithoutNotice === 'true' ?this.tenantForm.patchValue({isSkipWithoutNotice:true}) :this.tenantForm.patchValue({isSkipWithoutNotice:false})}}
  // // {{this.tenantForm.value.isTryingToLocate === 'true' ?this.tenantForm.patchValue({isTryingToLocate:true}) :this.tenantForm.patchValue({isTryingToLocate:false})}}
  // // {{this.tenantForm.value.isTurnOverToCollections === 'true' ?this.tenantForm.patchValue({isTurnOverToCollections:true}) :this.tenantForm.patchValue({isTurnOverToCollections:false})}}
  // // {{this.tenantForm.value.isUnauthorizedPets === 'true' ?this.tenantForm.patchValue({isUnauthorizedPets:true}) :this.tenantForm.patchValue({isUnauthorizedPets:false})}}
  // // {{this.tenantForm.value.isUtilitiesNonPayment === 'true' ?this.tenantForm.patchValue({isUtilitiesNonPayment:true}) :this.tenantForm.patchValue({isUtilitiesNonPayment:false})}}

  // }
  //       }
  //     },err=>{
  //       console.log(err)
  //     });

  //   }
  edit(obj1) {
    console.log(obj1);
    this.tenantDetailObj = obj1;
    this.tenantForm.reset();
    this.flag_form = true;
    this.flag_table = false;
    const obj = this;
    const token = this.DataServiceObj.getUserToken();

    obj.DataServiceObj.tenantSales('admin/tenantFeedbackSetting/detailByIdTenantFeedbackSettingDetailsWithoutToken', { id: obj1.id }).subscribe(res => {
      obj.response = res;
      if (obj.response.Status == 200) {
        if (obj.response.Data != null) {
          console.log(obj.response.Data[0]);
          obj.tenantForm.patchValue(obj.response.Data[0]);
          { { obj.tenantForm.value.isAuthorizedOccupants === 'true' ? obj.tenantForm.patchValue({ isAuthorizedOccupants: true }) : obj.tenantForm.patchValue({ isAuthorizedOccupants: false }); } }
          { { obj.tenantForm.value.isDamages === 'true' ? obj.tenantForm.patchValue({ isDamages: true }) : obj.tenantForm.patchValue({ isDamages: false }); } }
          { { obj.tenantForm.value.isEvictionUDFilled === 'true' ? obj.tenantForm.patchValue({ isEvictionUDFilled: true }) : obj.tenantForm.patchValue({ isEvictionUDFilled: false }); } }
          { { obj.tenantForm.value.isGoodResidentNoVoilation === 'true' ? obj.tenantForm.patchValue({ isGoodResidentNoVoilation: true }) : obj.tenantForm.patchValue({ isGoodResidentNoVoilation: false }); } }
          { { obj.tenantForm.value.isKeysNotReturned === 'true' ? obj.tenantForm.patchValue({ isKeysNotReturned: true }) : obj.tenantForm.patchValue({ isKeysNotReturned: false }); } }
          { { obj.tenantForm.value.isLatePayments === 'true' ? obj.tenantForm.patchValue({ isLatePayments: true }) : obj.tenantForm.patchValue({ isLatePayments: false }); } }
          { { obj.tenantForm.value.isNSFCheckCount === 'true' ? obj.tenantForm.patchValue({ isNSFCheckCount: true }) : obj.tenantForm.patchValue({ isNSFCheckCount: false }); } }
          { { obj.tenantForm.value.isNoticeToVacate === 'true' ? obj.tenantForm.patchValue({ isNoticeToVacate: true }) : obj.tenantForm.patchValue({ isNoticeToVacate: false }); } }
          { { obj.tenantForm.value.isOtherLeaseViolations === 'true' ? obj.tenantForm.patchValue({ isOtherLeaseViolations: true }) : obj.tenantForm.patchValue({ isOtherLeaseViolations: false }); } }
          { { obj.tenantForm.value.isPaidInFull === 'true' ? obj.tenantForm.patchValue({ isPaidInFull: true }) : obj.tenantForm.patchValue({ isPaidInFull: false }); } }
          { { obj.tenantForm.value.isRentNonPaymentAmount === 'true' ? obj.tenantForm.patchValue({ isRentNonPaymentAmount: true }) : obj.tenantForm.patchValue({ isRentNonPaymentAmount: false }); } }
          { { obj.tenantForm.value.isSection8Fraud === 'true' ? obj.tenantForm.patchValue({ isSection8Fraud: true }) : obj.tenantForm.patchValue({ isSection8Fraud: false }); } }
          { { obj.tenantForm.value.isSection8Violations === 'true' ? obj.tenantForm.patchValue({ isSection8Violations: true }) : obj.tenantForm.patchValue({ isSection8Violations: false }); } }
          { { obj.tenantForm.value.isSkipWithoutNotice === 'true' ? obj.tenantForm.patchValue({ isSkipWithoutNotice: true }) : obj.tenantForm.patchValue({ isSkipWithoutNotice: false }); } }
          { { obj.tenantForm.value.isTryingToLocate === 'true' ? obj.tenantForm.patchValue({ isTryingToLocate: true }) : obj.tenantForm.patchValue({ isTryingToLocate: false }); } }
          { { obj.tenantForm.value.isTurnOverToCollections === 'true' ? obj.tenantForm.patchValue({ isTurnOverToCollections: true }) : obj.tenantForm.patchValue({ isTurnOverToCollections: false }); } }
          { { obj.tenantForm.value.isUnauthorizedPets === 'true' ? obj.tenantForm.patchValue({ isUnauthorizedPets: true }) : obj.tenantForm.patchValue({ isUnauthorizedPets: false }); } }
          { { obj.tenantForm.value.isUtilitiesNonPayment === 'true' ? obj.tenantForm.patchValue({ isUtilitiesNonPayment: true }) : obj.tenantForm.patchValue({ isUtilitiesNonPayment: false }); } }

          console.log(obj.tenantForm.value);
        }
      }
    });

  }
}
export function removeSpaces(control: AbstractControl) {
  if (control && control.value && !control.value.toString().replace(/\s/g, '').length) {
    control.setValue('');
    return { required: true };
  }
  else {
    return null;
  }
}
